import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_ctx.showAlert)
    ? (_openBlock(), _createBlock(_component_v_alert, {
        key: 0,
        class: _normalizeClass(["feedback-alert", _ctx.borderColorObject]),
        border: "start",
        "close-label": "Close Alert",
        color: "white",
        "text-color": "black",
        "border-color": _ctx.getEmphasisColor,
        density: "compact",
        closable: "",
        "onClick:close": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-alert')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.text), 1)
        ]),
        _: 1
      }, 8, ["class", "border-color"]))
    : _createCommentVNode("", true)
}